/* eslint-disable no-console */

import React from 'react';
import { createIntl, createIntlCache } from 'react-intl';
import { SearchPage } from './containers';
import categoryConfig from './categoryConfig';

const cache = createIntlCache();
const messagesInLocale = require(`./translations/${process.env.REACT_APP_LANG || 'pl'}.json`);

const intl = createIntl(
  {
    locale: process.env.REACT_APP_LANG,
    messages: messagesInLocale,
    onError: (error) => {
      return;
    },
  },
  cache
);

const categoryRoutesConfiguration = () => {
  return categoryConfig.map(cat => ({
    countries: cat.countries,
    key: cat.key,
    pageName: cat.pageName,
    path: intl.formatMessage({ id: cat.translationKey }),
    name: cat.pageName,
    component: props => (
      <SearchPage
        categoryConfig={{
          header: intl.formatMessage({ id: cat.headerKey }),
          description: intl.formatMessage({ id: cat.descriptionKey }),
          metaTitle: intl.formatMessage({ id: cat.metaTitleKey }),
          metaDescription: intl.formatMessage({ id: cat.metaDescriptionKey }),
        }}
        pageName={cat.pageName}
        {...props}
      />
    ),
    loadData: (params, search) => SearchPage.loadData(params, search, cat.key),
  }));
};

export default categoryRoutesConfiguration;
